import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var GitBranch = createReactComponent("GitBranch", ["svg", defaultAttributes, [["line", {
  x1: "6",
  y1: "3",
  x2: "6",
  y2: "15",
  key: "1k99od"
}], ["circle", {
  cx: "18",
  cy: "6",
  r: "3",
  key: "1r01jq"
}], ["circle", {
  cx: "6",
  cy: "18",
  r: "3",
  key: "l375l1"
}], ["path", {
  d: "M18 9a9 9 0 01-9 9",
  key: "1yrk5u"
}]]]);
export default GitBranch;